import React from 'react';

const LoanQuoteStep2 = ({
        loanQuotation,
        onSubmitApplication,
        onDeclineApplication,
        isSubmitting,
        disableSubmission
    }) => {

    const article = loanQuotation.term === 84 ? 'an' : 'a';
    return (
        <form onSubmit={onSubmitApplication}>
            <h4>Loan quotation</h4>
            <p>Here's your quotation, based on the information you gave us.</p>
            <p>
                £{loanQuotation.loanAmount} financed over {article} {loanQuotation.term} month term works out as {loanQuotation.term} monthly payments of £{loanQuotation.regularRepayment} which is a flat rate of {loanQuotation.rate}%.
            </p>
            <p>We've also sent these details to the email address you provided.</p>
            {disableSubmission ? (
                <div className="row g-3 mx-auto">
                    <div className="col-md-3">
                        <button type="button" className="btn btn-primary w-100" onClick={onDeclineApplication}>
                            New quote
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    <p>If you'd like to proceed with the loan application, just click 'Apply' now.</p>
                    <div className="row g-3 mx-auto">
                        <div className="col-md-3">
                            <button className="btn decline-btn w-100" onClick={onDeclineApplication}>No thanks</button>
                        </div>
                        <div className="col-md-3">
                            <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                                {isSubmitting ? "Sending..." : "Apply"}
                            </button>
                        </div>
                    </div>
                </>
            )}
        </form>
    );
}

export default LoanQuoteStep2;
